import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import Image from "next/image";

interface DialogDemoProps {
  open: React.ReactNode;
  src: string;
}

export function DialogDemo({ open, src }: DialogDemoProps) {
  return (
    <Dialog>
      <DialogTrigger>{open}</DialogTrigger>
      <DialogContent className="max-w-[300px] sm:max-w-[425px] lg:max-w-[800px] max-h-full overflow-hidden p-0">
        <Image
          src={src}
          alt={`University Image `}
          className="h-full w-full object-cover"
          width={500}
          height={300}
          loading="lazy"
        />
      </DialogContent>
    </Dialog>
  );
}
